import React from "react";
import PropTypes from "prop-types";
import CSSReset from "@tds/core-css-reset";
import Notification from "@tds/core-notification";
import Text from "@tds/core-text";
import { withTranslation } from "react-i18next";
import { isIE } from "react-device-detect";
import GlobalMessage from "./Message";
import useMessage from "../hooks/useMessage";

// A wrapper for main content.
function Page({ children, i18n, t }) {
  // For use with Global Message.
  const messageId = useMessage();
  return (
    <div className="tds-page">
      <CSSReset />
      {isIE && (
        <Notification variant="warning" copy={i18n.language}>
          <Text size="large" bold>
            {t("iEWarning")}
          </Text>
        </Notification>
      )}
      {/* Optional Message to be displayed if msgId query param is used in url */}
      {messageId && (
        <GlobalMessage
          message={{
            name: "",
            status: "",
            displayedText: "",
            messageId,
          }}
          locale={i18n.language}
        />
      )}
      <main>{children}</main>
    </div>
  );
}

Page.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  t: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    language: PropTypes.string,
  }).isRequired,
};

Page.defaultProps = {
  children: null,
};

export default withTranslation()(Page);
